import { render, staticRenderFns } from "./DropdownProvider.vue?vue&type=template&id=bbd4a08a"
import script from "./DropdownProvider.vue?vue&type=script&lang=js"
export * from "./DropdownProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports